/* @flow */
import Vue from 'vue'
import App from '@/App';
import router from '@/router';
import store from '@/store';
import './permission'; // 全局路由过滤器
import { extract422Message } from '@/utils/utils.js';
import 'babel-polyfill';
import Es6Promise from 'es6-promise';
// eslint-disable-next-line flowtype-errors/show-errors
import Print from 'vue-print-nb'
Es6Promise.polyfill();

// import 'element-ui/lib/theme-chalk/index.css';
import '../public/page/assets/elementTheme/theme/index.css'; // 引入自定义主题
// set plugin
import Element from 'element-ui';
import AgotoZUI from '@/plugins/index.js';
import FormControls from '@/views/approval/project/FormControls/index.js';

console.log('AgotoZUI', AgotoZUI);

Vue.use(Element);
Vue.use(AgotoZUI);
Vue.use(FormControls);
Vue.use(Print);


// global scss
import '@/styles/index.scss';
import '@/styles/font/iconfont.css';
import variables from '@/styles/export.scss';

mixinProperty();
setConfig();

/* eslint-disable no-new */
new Vue({
  el: '#appTmp',
  router,
  store,
  render: h => h(App)
});

/* 混入实例全局属性 */
function mixinProperty(): void {
  Vue.prototype.GetCssConstGlobal = (globalCssKey: string): string => {
    const variablesMap = variables;
    return variablesMap[`scss-const-${globalCssKey}`];
  }
  // mount protype function
  Vue.prototype.agUtil = {
    extract422Message
  };
}

/* set environment setting */
function setConfig(): void {
  Vue.config.debug = process.env.NODE_ENV !== 'production';
  Vue.config.devtools = process.env.NODE_ENV !== 'production';
  Vue.config.productionTip = process.env.NODE_ENV !== 'production';
  Vue.config.performance = process.env.NODE_ENV !== 'production';
}